/* global axios */
import ApiClient from './ApiClient';

class ContactActivitiesAPI extends ApiClient {
  constructor() {
    super('contacts', { accountScoped: true });
  }

  get(contactId, page = 1) {
    return axios.get(`${this.url}/${contactId}/activities`, {
      params: { page },
    });
  }
}

export default new ContactActivitiesAPI();
